import React, { Component } from 'react';

class IconIssueDescriptionBlue extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="11.923" height="14.904" viewBox="0 0 11.923 14.904">
                <path id="Icon_material-description" data-name="Icon material-description" d="M13.452,3H7.49A1.488,1.488,0,0,0,6.007,4.49L6,16.413A1.488,1.488,0,0,0,7.483,17.9h8.95a1.5,1.5,0,0,0,1.49-1.49V7.471Zm1.49,11.923H8.981v-1.49h5.961Zm0-2.981H8.981v-1.49h5.961ZM12.707,8.216v-4.1l4.1,4.1Z" transform="translate(-6 -3)" fill="#1d53a5" />
            </svg>

        );
    }
}

export default IconIssueDescriptionBlue;